/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/autofilltext/dropdownitem/dropdownitem_styles';



/* ========== ~~~~~~~~~~ DROP DOWN ITEM ~~~~~~~~~~ ========== */
const DropDownItem =(props)=> {
    const renderItemText = ()=>{
        let item = props.name;
        let searchText = props.searchTerm;

        let beginningText = item.slice(0,item.toLowerCase().indexOf(searchText.toLowerCase()));
        let highlightedText = item.slice(item.toLowerCase().indexOf(searchText.toLowerCase()), item.toLowerCase().indexOf(searchText.toLowerCase())+searchText.length);
        let endingText = item.slice(item.toLowerCase().indexOf(searchText.toLowerCase())+searchText.length, item.length);
        return <div><span>{beginningText}</span><span className={`highlight`} >{highlightedText}</span><span>{endingText}</span> </div>
    };
    return (
        <div onClick={()=>props.handleSelect(props.item)} className={`dropDownItem ${props.classes.dropDownItem}`}>
            {renderItemText()}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DropDownItem);
